import React from "react"
import Layout from "../../../shared/components/organisms/layout/layout"
import ContentCreate from "../../../components/organisms/content-create/content-create"
import { useStaticQuery, graphql } from "gatsby"
import { siteUrl } from "../../../shared/utils/siteUrl"

const ContenidoUsuarias = props => {
  const resultQuery = useStaticQuery(
    graphql`
      query GET_STEP_CONTENT {
        allContentfulNolMagazinCreaConNosotras {
          nodes {
            pasoAPaso {
              descripcionPaso {
                descripcionPaso
              }
              imagenPaso {
                file {
                  url
                }
                description
              }
              numeroDePaso
              previsualizacionVideo {
                file {
                  url
                }
                description
              }
              titulo
              video
            }
          }
        }
      }
    `
  )
  // send active modal to layout
  const [modalActive, setModalActive] = React.useState()
  // var news_info=props.dataProp
  const [isMobile, setMobileBool] = React.useState(false)
  // send active modal to layout
  const updateDimensions = () => {
    setMobileBool(window.innerWidth < 1024)
  }

  var homeLink = siteUrl + "/"

  React.useEffect(() => {
    updateDimensions()
    window.addEventListener("resize", updateDimensions)

    if (localStorage.getItem("TOKEN_INFO") === null) {
      sessionStorage.setItem(
        "NEXT_PAGE",
        "/magazin/nuestro-mundo/contenido-usuarias/"
      )
      window.location.href = homeLink + "login/"
    }

    return () => {
      window.removeEventListener("resize", updateDimensions)
    }
  }, [])
  return (
    <Layout title="Contenido usuarias" mobile={isMobile} modalActive={modalActive}>
      <ContentCreate
        mobile={isMobile}
        setModalActive={setModalActive}
        steps={
          resultQuery.allContentfulNolMagazinCreaConNosotras.nodes[0].pasoAPaso
        }
      />
    </Layout>
  )
}

export default ContenidoUsuarias
